// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2uIyv","checkboxCol":"Table_checkboxCol__2mo7a","emailCol":"Table_emailCol__34sSr","actionCol":"Table_actionCol__1UXMU"};